import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const clientsKpis /*: WarehouseKPI[] */ = [
  // Client Order Accuracy
  {
    id: 'client_order_accuracy',
    category: 'clients',
    title: 'Client Order Accuracy',
    description: 'Percentage of client orders fulfilled without errors',
    unit: '%',
    formula:
      '(COUNT(orders WHERE status = "fulfilled_perfect") / COUNT(orders)) * 100 GROUP BY client_id',
    tags: ['quality'],
    benchmark: {
      standards: {
        site: {
          target: 99,
          warning: { lower: 98 },
          critical: { lower: 95 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P90D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 95 },
            { label: 'Warning', min: 95.01, max: 98 },
            { label: 'Target', min: 98.01, max: 99 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P90D',
    drillDimensions: ['client_id', 'order_type', 'shipping_method'],
    alertTopic: 'warehouse.alerts.clients.order_accuracy',
  },
  // Client On-time Delivery
  {
    id: 'client_ontime_delivery',
    category: 'clients',
    title: 'Client On-time Delivery',
    description:
      'Percentage of client orders delivered on or before promised date',
    unit: '%',
    formula:
      '(COUNT(orders WHERE actual_delivery <= promised_delivery) / COUNT(orders)) * 100 GROUP BY client_id',
    tags: ['shipping', 'quality'],
    benchmark: {
      standards: {
        site: {
          target: 98,
          warning: { lower: 95 },
          critical: { lower: 90 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 90 },
            { label: 'Warning', min: 90.01, max: 95 },
            { label: 'Target', min: 95.01, max: 98 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['client_id', 'shipping_method', 'destination_region'],
    alertTopic: 'warehouse.alerts.clients.ontime_delivery',
    processType: ActivityEventProcessType.SHIPPING,
  },
  // Client Storage Cost
  {
    id: 'client_storage_cost',
    category: 'clients',
    title: 'Client Storage Cost',
    description: 'Average monthly storage cost per unit for each client',
    unit: '$',
    formula: 'SUM(storage_cost) / SUM(units_stored) GROUP BY client_id',
    tags: ['storage', 'cost'],
    benchmark: {
      standards: {
        site: {
          target: 0.5,
          warning: { upper: 0.75 },
          critical: { upper: 1 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P90D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 1 },
            { label: 'Warning', min: 1.01, max: 0.75 },
            { label: 'Target', min: 0.76, max: 0.5 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P90D',
    drillDimensions: ['client_id', 'product_category', 'storage_type'],
    alertTopic: 'warehouse.alerts.clients.storage_cost',
  },
];

export default clientsKpis;
